(function () {
  function injectStyle(shadowRoot) {
    if (!shadowRoot || shadowRoot.querySelector('#custom-vdslz-style')) return;

    const style = document.createElement('style');
    style.id = 'custom-vdslz-style';

    style.textContent = `
      .vdslz-carousel {
        float: none !important;
        margin-left: 0 !important;
      }
    `;

    shadowRoot.appendChild(style);
  }

  function findShadowRoots(root = document) {
    root.querySelectorAll('*').forEach(el => {
      if (el.shadowRoot) {
        injectStyle(el.shadowRoot);
        findShadowRoots(el.shadowRoot);
      }
    });
  }

  // Run after page/app has loaded
  window.addEventListener('load', () => {
    findShadowRoots();
  });

  // Watch for Shopify/app elements being added later
  const observer = new MutationObserver(() => {
    findShadowRoots();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Also retry for dynamically-created Shadow DOM
  setInterval(() => {
    findShadowRoots();
  }, 1000);
})();